module.exports = __webpack_public_path__ + "static/avalon-bw-fcc286b3f77767eec89dce320797a42f.jpg";